import type {BioIconProps} from '../../icons/common-types'

export default function OutdoorsGearInsiderLogo({...attributes}: BioIconProps) {
  return (
    <div className="domain_logo flex w-fit items-center gap-2 text-2xl font-semibold text-white tablet:gap-1 tablet:text-base">
      <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
        <g clipPath="url(#clip0_4753_138935)">
          <circle cx="18" cy="18" r="18" fill="#FFAD62" />
          <path d="M8.47372 20.5L18 4L27.5263 20.5H8.47372Z" stroke="black" />
          <path d="M8.47372 29.5L18 13L27.5263 29.5H8.47372Z" stroke="black" />
        </g>
        <defs>
          <clipPath id="clip0_4753_138935">
            <rect width="36" height="36" fill="white" />
          </clipPath>
        </defs>
      </svg>
      <span>Outdoor Gear Insider</span>
    </div>
  )
}
